module.exports = __webpack_public_path__ + "static/media/LocationIcon.48d80ef6.svg";